<template>
    <div>
        <h3>列表 &nbsp;&nbsp;&nbsp; Total: {{ sum }} 条</h3>

        <el-form class="el_head_search" ref="form" :model="form" label-width="80px" label-position="left">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="topic" prop="topic">
                        <el-select v-model="form.topic" placeholder="请选择" style="width: 100%">
                            <el-option v-for="item in optionList" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <h5>
            <span></span>
            <span>
                <el-button type="primary" size="small" @click="handleAdd">添加</el-button>
                <el-button type="primary" size="small" :disabled="multipleData.length === 0" :loading="deleteLoad" @click="handleDelete">Delete</el-button>
            </span>
        </h5>

        <el-table v-loading="tableLoad" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" fixed></el-table-column>
            <el-table-column label="序号" width="60">
                <template slot-scope="scope">
                    {{ scope.row.sort }}
                </template>
            </el-table-column>
            <el-table-column label="en-title" width="200">
                <template slot-scope="scope">
                    {{ scope.row.en.title }}
                </template>
            </el-table-column>
            <el-table-column label="en-description" width="300">
                <template slot-scope="scope">
                    {{ scope.row.en.summary }}
                </template>
            </el-table-column>

            <el-table-column label="zh-title" width="200">
                <template slot-scope="scope">
                    {{ scope.row.zh.title }}
                </template>
            </el-table-column>
            <el-table-column label="zh-description" width="300">
                <template slot-scope="scope">
                    {{ scope.row.zh.summary }}
                </template>
            </el-table-column>

            <el-table-column label="topic" width="180">
                <template slot-scope="scope">
                    <el-tag size="small">{{ scope.row.topic }}</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="banner" width="120">
                <template slot-scope="scope">
                    <img :src="`https://asset.promptport.ai/files${scope.row.banner_url}`" alt="" style="height: 50px" />
                </template>
            </el-table-column>

            <el-table-column label="是否外链">
                <template slot-scope="scope">
                    {{ scope.row.web_link ? '是' : '否' }}
                </template>
            </el-table-column>

            <el-table-column label="外链地址" width="160">
                <template slot-scope="scope">
                    {{ scope.row.web_link ? scope.row.link_url : '' }}
                </template>
            </el-table-column>
            <el-table-column prop="view" label="浏览量"></el-table-column>
            <el-table-column label="Detail" width="70" fixed="right" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleView(scope.row)" type="text" size="small">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <ModalCom v-if="modalFlag" :dialogVisible="modalFlag" :type="modalType" :initData="modalData" :isMain="0" @closeModal="handleCloseModal" />
    </div>
</template>

<script>
import serverApi from '../../../server/index';
import ModalCom from '../components/modal.vue';

export default {
    name: 'list-blog',
    components: {
        ModalCom,
    },
    data() {
        return {
            sum: 0,
            tableData: [],
            tableLoad: false,

            multipleData: [],
            deleteLoad: false,

            optionList: ['Product Updates', 'Market cooperation', 'Major issues', 'Related activities'],
            form: {
                topic: '',
            },

            params: {
                size: 10,
                page: 1,
            },
            total: 0,

            // modal
            modalFlag: false,
            modalType: 'add',
            modalData: null,
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        async initData(_params) {
            this.tableLoad = true;
            try {
                const params = {
                    ...this.params,
                    ..._params,
                    is_main: 0,
                };
                const { data } = await serverApi.blogList(params);
                console.log('blog list---->', data, params);
                if (data.code !== 0) throw new Error(data.error);
                this.isAdd = data.data.length === 0;
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.tableLoad = false;
            }
        },
        handleCurrentChange(val) {
            this.params.page = val;
            this.initData();
        },
        handleView(row) {
            console.log('row---->', row);
            this.modalData = row;
            this.modalType = 'edit';
            this.modalFlag = true;
        },
        search() {
            this.params = { page: 1, size: 10 };
            const topic = this.form.topic.toLowerCase();
            this.initData(topic);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.initData(this.form);
        },
        handleAdd() {
            this.modalType = 'add';
            this.modalFlag = true;
        },
        handleCloseModal(isUpdate) {
            console.log('close--->', isUpdate);
            this.modalFlag = false;
            this.modalData = null;
            if (isUpdate) {
                this.initData();
            }
        },
        handleSelectionChange(val) {
            this.multipleData = val;
            console.log('multipleData: []', this.multipleData);
        },
        handleDelete() {
            this.deleteLoad = true;
            const ids = this.multipleData.map(item => item._id);
            console.log('ids', ids);
            serverApi
                .blogDelete({ ids })
                .then(res => {
                    if (res.data.code === 0) {
                        this.$message({
                            message: 'Delete successfully',
                            type: 'success',
                        });
                        this.initData();
                    } else {
                        this.$message({
                            message: res.data.msg || res.data.error,
                            type: 'error',
                        });
                    }
                })
                .catch(e => {
                    console.log('delete error', e);
                    this.$message({
                        message: e.data.error || e.data.msg,
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.deleteLoad = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}

h4 {
    margin-bottom: 30px;
}

h5 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.demo-input-suffix {
    display: flex;
    align-items: center;
    margin-right: 20px;
}
</style>
